import React from "react";
import s from "./DogBooking.css";
import { flowRight as compose } from "lodash";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";
import dogIcon from "../../../../public/SiteImages/dog-icon.svg";
import heartIcon from "../../../../public/SiteImages/heart-icon.svg";
import hostIcon from "../../../../public/SiteImages/host-icon.svg";
import flagIcon from "../../../../public/SiteImages/flag-icon.svg";
import founderIcon from "../../../../public/SiteImages/founder.svg";
import dogIcons from "../../../../public/SiteImages/dogIcon.svg";
import dogPowIcons from "../../../../public/SiteImages/dogPow.svg";
import dogOne from "../../../../public/SiteImages/dogOne.svg";
import dogTwo from "../../../../public/SiteImages/dogTwo.svg";
import dogThree from "../../../../public/SiteImages/dogdemo.png";
import messages from "../../../locale/messages";

class DogBooking extends React.Component {
  render() {
    return (
      <div className={s.container}>
        <h2 className={s.heading}>
          <FormattedMessage {...messages.dogBookingHeading} />
        </h2>
        <div className={s.dogBackground}>
          <div className={s.subHeading}>
            <FormattedMessage {...messages.dogBookingHeadingSecond} />
          </div>
          <div className={s.grid}>
            {/* Filter by Important Dog Needs */}
            <div className={s.card}>
              <img src={dogIcon} alt="Dog Icon" className={s.icon} />
              <h3 className={s.cardHeading}>
                <FormattedMessage {...messages.filterByDog} />
              </h3>
              {/* <div className={s.imageGroup}>
                <img src={dogOne} alt="Dog Icon" />
                <img src={dogTwo} alt="Dog Icon" />
              </div> */}

              <img src={dogThree} alt="Dog Icon" className={s.w100} />
            </div>

            {/* Every Booking Supports Dog Wellbeing */}
            <div className={s.card}>
              <img src={heartIcon} alt="Heart Icon" className={s.icon} />
              <h3 className={`${s.cardHeading} ${s.mb0}`}>
                <FormattedMessage {...messages.everyBookingDog} />
              </h3>
              <img src={dogPowIcons} alt="Host Icon" />
            </div>

            {/* Created by Dog-Loving Hosts */}
            <div className={s.card}>
              <img src={hostIcon} alt="Host Icon" className={s.icon} />
              <h3 className={s.cardHeading}>
                <FormattedMessage {...messages.createdDog} />
              </h3>
              <img src={founderIcon} alt="Host Icon" />
              <p className={s.cardNote}>
                <FormattedMessage {...messages.createdDogDes} />
              </p>
            </div>

            {/* Support Local */}
            <div className={s.card}>
              <img src={flagIcon} alt="Flag Icon" className={s.icon} />
              <h3 className={s.cardHeading}>
                <FormattedMessage {...messages.supportLocal} />
              </h3>
              <img src={dogIcons} alt="Host Icon" />
              <p className={s.cardNote}>
                <FormattedMessage {...messages.supportLocalDes} />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(injectIntl, withStyles(s))(DogBooking);
